import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Menu,
  Grid,
  Form,
  Button,
  Input,
  Dropdown,
  Tab,
  Message,
  Modal,
} from "semantic-ui-react";
import DataLayerModal from "./DataLayerModal";
import styles from "./DataConnections.module.css";
import DatabaseListing from "./DatabaseListing";
import { DataProvider } from "./DataProvider";
import axios from "axios"; // For making API requests
import dataconnection from "../../../api/DataConnection/dataconnection";
import vapiVariableService from "../../../services/vapiVariableService";
import ConnectionList from "./ConnectionList";
import { DataContext } from "./DataProvider";

const authOptions = [
  { key: "none", value: "none", text: "None" },
  { key: "bearer", value: "bearer", text: "Bearer Token" },
  { key: "basic", value: "basic", text: "Basic Auth" },
  { key: "apikey", value: "apikey", text: "Api Key" },
];

// Normalize various forms of auth type values to our dropdown values
const normalizeAuthType = (raw) => {
  if (!raw || typeof raw !== "string") return "none";
  const s = raw.trim().toLowerCase();
  if (s.includes("bearer")) return "bearer"; // handles "bearer", "Bearer", "Bearer Token"
  if (s.includes("basic")) return "basic"; // handles "basic", "Basic Auth"
  if (s === "apikey" || (s.includes("api") && s.includes("key"))) return "apikey"; // handles "api key"
  if (s === "none" || s === "") return "none";
  return "none";
};

const Dataconnectionwrapper = ({ variableMode = false }) => {
  const { toolapiendpoint, loadToolApiendpoint, connections } =
    useContext(DataContext);
  const topRef = useRef(null); // Create a ref for the scroll target
  // State declarations with corrected naming
  const [timeInSWC, setTimeInSWC] = useState("");
  const [showConnectionform, setShowConnectionform] = useState(true);
  const [activeTab, setActiveTab] = useState("params");
  const [modalStatus, setmodalStatus] = useState(false);
  const [databases, setDatabases] = useState([]);
  const [selectedAuthType, setSelectedAuthType] = useState("none");
  const [selectedBodyType, setSelectedBodyType] = useState("formdata");
  const [initFormdata, setinitFormdata] = useState({});
  const [keyValuePairs, setKeyValuePairs] = useState([{ key: "", value: "" }]);
  const [operation, setOperation] = useState("add");
  const [rawBody, setRawBody] = useState("{}");
  const [responseOutput, setResponseOutput] = useState(null);
  const [method, setMethod] = useState("get"); // HTTP method
  const [endpointUrl, setEndpointUrl] = useState("");
  const [headers, setHeaders] = useState([{ key: "", value: "" }]); // Dynamic headers
  const [paramskeyValuePairs, setParamKeyValuePairs] = useState([
    { key: "", value: "" },
  ]);
  // States for mapping response in settings
  const [databaseColumns, setDatabaseColumns] = useState([]); // Example database columns
  const [availableKeys, setAvailableKeys] = useState([]); // Keys from the response tab
  // Initialize mappings with default empty values for each column
  const [mappings, setMappings] = useState({});
  const [defaultMappings, setDefaultMappings] = useState({}); // Corrected from defualtMappings
  // Usage example
  const [selectedDatabase, setSelectedDatabase] = useState(null);
  const [errorMessage, setErrorMessage] = useState(""); // Error message state
  const [errorMessageType, setErrorMessageType] = useState("warning"); // Error message state
  const [dbloaderSatus, setDbloaderStatus] = useState(true);
  const [conloaderSatus, setConloaderStatus] = useState(true);
  const [availableDatabases, setAvailableDatabases] = useState([]);
  const [availableKeyCopy, setAvailableKeyCopy] = useState([]); // Corrected from avaialbeKeycopy
  const [veriable, setveriable] = useState([]);
  const [editMode, setEditMod] = useState(false);
  const [editInitiated, setEditInitiated] = useState(false); // Only fetch variable defaults during edit
  const [changeUrl, setChangeUrl] = useState("No");
  const [authConfig, setAuthConfig] = useState({
    id: null,
    endpoint_name: "",
    type: "none",
    username: "",
    password: "",
    token: "",
    apiKey: {
      key: "",
      value: "",
      place: "header",
    },
  });


  const [modalOpen, setModalOpen] = useState(false);
  const [selectedText, setSelectedText] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [customValue, setCustomValue] = useState("");
  const [timeUnit, setTimeUnit] = useState("");
  const [fromNumberCustomValue, setFromNumberCustomValue] = useState("");
  const inputRef = useRef(null);
  const variableOptions = [
    { key: "now", text: "NOW", value: "NOW" },
    { key: "from_number", text: "FROM NUMBER", value: "FROM_NUMBER" },
  ];
  // New variable input (variableMode - Settings Tab)
  const [newVariableInput, setNewVariableInput] = useState("");
  const [newVariableLoading, setNewVariableLoading] = useState(false);
  const [variableList, setVariableList] = useState([]);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteTargetRow, setDeleteTargetRow] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [listEditingResetTick, setListEditingResetTick] = useState(0);
  const [editingVarId, setEditingVarId] = useState(null);
  const [editingOriginalKey, setEditingOriginalKey] = useState(null);

  const normalizeVariableName = (raw) => {
    if (typeof raw !== "string") return "";
    const trimmed = raw.trim();
    return trimmed.toUpperCase();
  };

  const isValidVariableName = (name) => {
    // Uppercase letters, numbers, underscore only; no spaces; non-empty handled externally
    return /^[A-Z0-9_]+$/.test(name);
  };

  const handleAddNewVariable = async () => {
    // Leading/trailing spaces ignored; auto uppercase
    const upper = normalizeVariableName(newVariableInput);
    if (!upper) {
      setErrorMessageWithTimeout("The variable field can not be empty.", "error");
      return;
    }
    if (upper.length < 3) {
      setErrorMessageWithTimeout("Variable name must be at least 3 characters.", "error");
      return;
    }
    if (!isValidVariableName(upper)) {
      setErrorMessageWithTimeout(
        "Only uppercase letters (A–Z), digits (0–9), and underscores (_) are allowed. Spaces or special characters are not permitted.",
        "error"
      );
      return;
    }

    try {
      setNewVariableLoading(true);
      const payload = {
        key_name: upper,
      };
      const res = await dataconnection.addDataVariable(payload);
      console.log(res, "res_variable");
      if (res && (res.status === 'true')) {
        setErrorMessageWithTimeout("Variable added successfully.", "success");
        
        setNewVariableInput("");
        // Append locally (dedupe by id or key_name so same data maps only once)
        setVariableList((prev) => {
          const prior = Array.isArray(prev) ? prev : [];
          const newId = res?.data?.id || undefined;
          const newKey = upper;
          const exists = prior.some((it) => (
            (it?.id && newId && it.id === newId) ||
            (String(it?.key_name || '').toUpperCase() === newKey)
          ));
          if (exists) {
            return prior.map((it) => {
              if ((it?.id && newId && it.id === newId) || (String(it?.key_name || '').toUpperCase() === newKey)) {
                return { ...it, id: newId ?? it.id, key_name: newKey };
              }
              return it;
            });
          }
          return [...prior, { key_name: newKey, id: newId }];
        });
      }else if(res && (res.status === 'use_key')){
        setErrorMessageWithTimeout(res.message || "This variable key already exists but is not yet mapped to any endpoint. It has now been successfully mapped to the current endpoint.", "warning");
        setNewVariableInput("");
        // Append locally (dedupe by id or key_name so same data maps only once)
        setVariableList((prev) => {
          const prior = Array.isArray(prev) ? prev : [];
          const newId = res?.data?.id || undefined;
          const newKey = upper;
          const exists = prior.some((it) => (
            (it?.id && newId && it.id === newId) ||
            (String(it?.key_name || '').toUpperCase() === newKey)
          ));
          if (exists) {
            return prior.map((it) => {
              if ((it?.id && newId && it.id === newId) || (String(it?.key_name || '').toUpperCase() === newKey)) {
                return { ...it, id: newId ?? it.id, key_name: newKey };
              }
              return it;
            });
          }
          return [...prior, { key_name: newKey, id: newId }];
        });
      }
      else if(res && (res.status === 'refresh' || res.status === 'duplicate')){
        setErrorMessageWithTimeout(res.message, "error");
      }else {
        setErrorMessageWithTimeout(
          (res && (res.message || res.error)) || "Failed to add variable.",
          "error"
        );
      }
    } catch (e) {
      setErrorMessageWithTimeout(e?.message || "Failed to add variable.", "error");
    } finally {
      setNewVariableLoading(false);
    }
  };

  const handleStartEditVariable = (item) => {
    const varKey = (item?.key_name || item?.key || item?.name || item?.value || item?.text || item?.label || "").toString().toUpperCase();
    setNewVariableInput(varKey);
    setEditingVarId(item?.id || item?.ID || item?.value_id || null);
    setEditingOriginalKey(varKey);
  };

  const handleUpdateVariable = async () => {
    const upper = normalizeVariableName(newVariableInput);
    if (!upper) {
      setErrorMessageWithTimeout("The variable field can not be empty.", "error");
      return;
    }
    if (upper.length < 3) {
      setErrorMessageWithTimeout("Variable name must be at least 3 characters.", "error");
      return;
    }
    if (!isValidVariableName(upper)) {
      setErrorMessageWithTimeout(
        "Only uppercase letters (A–Z), digits (0–9), and underscores (_) are allowed. Spaces or special characters are not permitted.",
        "error"
      );
      return;
    }
    const existsOther = (Array.isArray(variableList) ? variableList : []).some((it) => {
      const id = it?.id || it?.ID || it?.value_id || null;
      const key = (it?.key_name || it?.key || it?.name || it?.value || it?.text || it?.label || "").toString().toUpperCase();
      return id !== editingVarId && key === upper;
    });
    if (existsOther) {
      setErrorMessageWithTimeout("This variable already exists.", "error");
      return;
    }
    try {
      setNewVariableLoading(true);
      const payload = { variable_id: editingVarId, key_name: upper };
      const res = await dataconnection.updateVariableConnection(payload);
      if (res && (res.status === true || res.status === 'true' || res.success === true || res.data)) {
        setVariableList((prev) => (Array.isArray(prev) ? prev.map((it) => {
          const id = it?.id || it?.ID || it?.value_id || null;
          if (id && editingVarId && id === editingVarId) {
            return { ...it, key_name: upper };
          }
          return it;
        }) : prev));
        if (editingOriginalKey && editingOriginalKey !== upper) {
          setMappings((prev) => {
            const out = { ...(prev || {}) };
            if (Object.prototype.hasOwnProperty.call(out, editingOriginalKey) && typeof out[upper] === 'undefined') {
              out[upper] = out[editingOriginalKey];
            }
            delete out[editingOriginalKey];
            return out;
          });
          setDefaultMappings((prev) => {
            const out = { ...(prev || {}) };
            if (Object.prototype.hasOwnProperty.call(out, editingOriginalKey) && typeof out[upper] === 'undefined') {
              out[upper] = out[editingOriginalKey];
            }
            delete out[editingOriginalKey];
            return out;
          });
        }
        setErrorMessageWithTimeout("Variable updated successfully.", "success");
        setEditingVarId(null);
        setEditingOriginalKey(null);
        setNewVariableInput("");
      } else {
        setErrorMessageWithTimeout((res && (res.message || res.error)) || "Failed to update variable.", "error");
      }
    } catch (e) {
      setErrorMessageWithTimeout(e?.message || "Failed to update variable.", "error");
    } finally {
      setNewVariableLoading(false);
    }
  };

  const handleSaveVariable = async () => {
    if (editingVarId) {
      await handleUpdateVariable();
    } else {
      await handleAddNewVariable();
    }
  };

  const handleDeleteVariableRow = async (row) => {
    try {
      setDeleteLoading(true);
      const id = row?.id || row?.ID || row?.value_id;
      const deletedKey = (row?.key_name || row?.key || row?.name || '').toString();
      const previouslySelectedMapping = (mappings && typeof mappings === 'object') ? mappings[deletedKey] : undefined;
      const res = await dataconnection.deleteVariableConnection({variable_id: id, key_name: deletedKey});
      if (res && (res.status === true || res.status === 'true' || res.success === true)) {
        setErrorMessageWithTimeout("Variable deleted successfully.", "success");
        setVariableList((prev) => (Array.isArray(prev) ? prev.filter((it) => (String(it?.key_name || it?.key || it?.name) !== deletedKey)) : []));
        // Remove mapping/default for this key
        setMappings((prev) => {
          const out = { ...(prev || {}) };
          delete out[deletedKey];
          return out;
        });
        setDefaultMappings((prev) => {
          const out = { ...(prev || {}) };
          delete out[deletedKey];
          return out;
        });
        // Restore previously selected mapping back to availableKeys for other variables
        if (previouslySelectedMapping) {
          setAvailableKeys((prev) => {
            const list = Array.isArray(prev) ? prev : [];
            if (list.includes(previouslySelectedMapping)) return list;
            return [...list, previouslySelectedMapping];
          });
        }
      } else {
        setErrorMessageWithTimeout((res && (res.message || res.error)) || "Failed to delete variable.", "error");
      }
    } catch (e) {
      setErrorMessageWithTimeout(e?.message || "Failed to delete variable.", "error");
    } finally {
      setDeleteLoading(false);
      setDeleteConfirmOpen(false);
      setDeleteTargetRow(null);
    }
  };
  const timeUnitOptions = [
    { key: "minute", text: "Minute", value: "MINUTE" },
    { key: "day", text: "Day", value: "DAY" },
    { key: "month", text: "Month", value: "MONTH" },
  ];

  // Ensure PHONE_NUMBER is always present as a default variable in variable mode
  useEffect(() => {
    if (!variableMode) return;
    setVariableList((prev) => {
      const prior = Array.isArray(prev) ? prev : [];
      const hasPhone = prior.some((it) => String(it?.key_name || it?.key || it?.name || '').toUpperCase() === 'PHONE_NUMBER');
      if (hasPhone) return prior;
      return [{ key_name: 'PHONE_NUMBER' }, ...prior];
    });
  }, [variableMode]);

  // Handle text selection in textarea
  const getSelectedText = () => {
    const input = inputRef.current;
    const selection = window.getSelection();
    const selected = selection.toString().trim();

    if (input && selected) {
      if (selected !== "") {
        setSelectedText(selected);
        setModalOpen(true);
      }
    }
  };

  // Handle text replacement
  const handleReplace = () => {
    if (dropdownValue && selectedText) {
      let replacementValue = "";

      if (dropdownValue === "NOW") {
        const normalizedOffset = customValue === "" ? 0 : customValue;
        const normalizedUnit = timeUnit || "MINUTE";
        replacementValue = `{{NOW_PLUS_${normalizedOffset}_${normalizedUnit}}}`;
      } else if (dropdownValue === "FROM_NUMBER") {
        // FROM_NUMBER is only valid in configure-variable-data (variableMode) context.
        if (!variableMode) {
          setModalOpen(false);
          setDropdownValue("");
          setSelectedText("");
          setCustomValue("");
          setTimeUnit("");
          return;
        }
        const trimmedCustom = (customValue || "").trim();
        setFromNumberCustomValue(trimmedCustom);
        replacementValue = "{{FROM_NUMBER}}"; // keep placeholder visible in URL
        // Auto-map the provided FROM_NUMBER custom value to PHONE_NUMBER default mapping for convenience.
        if (trimmedCustom) {
          setDefaultMappings((prev) => ({
            ...prev,
            PHONE_NUMBER: trimmedCustom,
          }));
        }
        // Also pre-select PHONE_NUMBER mapping to the FROM_NUMBER variable for edit UX.
        setMappings((prev) => ({
          ...(typeof prev === "object" && prev !== null ? prev : {}),
          PHONE_NUMBER: "FROM_NUMBER",
        }));
      } else {
        replacementValue = `{{${dropdownValue}}}`;
      }

      const newValue = endpointUrl.replace(selectedText, replacementValue);
      setEndpointUrl(newValue);
    }
    setModalOpen(false);
    setDropdownValue("");
    setSelectedText("");
    setCustomValue("");
    setTimeUnit("");
  };

  const setDbloaderStatusp = (status) => {
    setDbloaderStatus(status);
  };

  // Render database selection
  const renderDatabaseSelection = (selectedDatabase, handleDatabaseChange) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <label
          style={{ marginRight: "10px", fontWeight: "bold", minWidth: "120px" }}
        >
          Select Database:
        </label>
        <Dropdown
          placeholder="Select Database"
          selection
          options={availableDatabases}
          value={selectedDatabase}
          onChange={(e, { value }) => handleDatabaseChange(e, { value })} // Handle database selection
          style={{ flex: 1, paddingLeft: "1rem" }}
        />
      </div>
    );
  };

  // Function to handle the change when a database is selected
  const handleDatabaseChange = (e, { value }) => {
    const selectedDb = availableDatabases.find((db) => db.value === value);
    setSelectedDatabase(value); // Set the selected database in the state
    // Set the columns of the selected database
     setDatabaseColumns(selectedDb ? selectedDb.columns : []);
    
    // Reset mappings
    setMappings({});
    setDefaultMappings({}); // Corrected from setdefualtMappings

    // Extract and set available keys
    let extractedKeys = [];
    if (endpointUrl.includes("sheets.googleapis.com")) {
      extractedKeys = extractKeysFromResponseForSheet(responseOutput);
    } else {
      const newfirstValidValue = Object.values(responseOutput).find(
        (val) => Array.isArray(val) && val.length > 0
      );
      extractedKeys = extractKeysFromResponse(newfirstValidValue ?? []);
    }
    setAvailableKeys(extractedKeys);
    return;
  };

  // Function for mapping table column and response keys
  const handleMapping = (column, selectedKey) => {
    setMappings((prevMappings) => {
      const previousKey = prevMappings[column];
      const updatedMappings = { ...prevMappings, [column]: selectedKey };

      setAvailableKeys((prevKeys) => {
        const next = new Set(Array.isArray(prevKeys) ? prevKeys : []);
        // If there was a previous selection, add it back to the pool
        if (previousKey && previousKey !== "") {
          next.add(previousKey);
        }
        // If a new key is selected (non-empty), remove it from the pool for others
        if (selectedKey && selectedKey !== "") {
          next.delete(selectedKey);
        }
        return Array.from(next);
      });

      return updatedMappings;
    });
  };

  // Corrected function name from handleDefualtMapping to handleDefaultMapping
  const handleDefaultMapping = (column, default_value) => {
    setDefaultMappings((prevMappings) => {
      console.log(prevMappings, "prevMappings");
      const previousKey = prevMappings[column];
      const updatedMappings = { ...prevMappings, [column]: default_value };
      if (previousKey && previousKey !== default_value) {
        setAvailableKeys((prevKeys) =>
          prevKeys.filter((keyav) => keyav !== column)
        );
      }
      return updatedMappings;
    });
    setAvailableKeys((prevKeys) =>
      prevKeys.filter((key) => key !== default_value)
    );
  };

  function extractKeysFromResponse(obj, parentKey = "", keys = new Set()) {
    console.log("extractKeys", obj);
    if (typeof obj === "object" && obj !== null) {
      if (Array.isArray(obj)) {
        obj.forEach((item) => {
          extractKeysFromResponse(item, parentKey, keys);
        });
      } else {
        Object.entries(obj).forEach(([key, value]) => {
          const fullKey = parentKey ? `${parentKey}.${key}` : key;
          keys.add(fullKey);
          extractKeysFromResponse(value, fullKey, keys);
        });
      }
    }
    return Array.from(keys);
  }

  // Rendering settings mapping stuff
  const renderSettingsItems = (
    databaseColumns,
    availableKeys,
    handleMapping,
    mappings,
    defaultMappings, // Corrected parameter name
    handleDefaultMapping // Corrected parameter name
  ) => {
    return (
      <div style={{ marginTop: "20px" }}>
        {variableMode && (
          <div style={{ marginBottom: "16px" }}>
            <h4>Add Variable</h4>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Input
                placeholder="Enter variable name (e.g., MY_VARIABLE)"
                value={newVariableInput}
                onChange={(e) => setNewVariableInput(e.target.value)}
                onBlur={(e) => setNewVariableInput(normalizeVariableName(e.target.value))}
                maxLength={25}
                style={{ width: '90%' }}
              />
              <Button color="green" className={`btn linear-gradient yr-submitbtn btn-sm ${styles.button}`} onClick={handleSaveVariable} disabled={newVariableLoading}>
                {newVariableLoading ? (
                  <>
                     {editingVarId ? 'Updating...' : 'Adding...'}
                  </>
                ) : (
                  <>
                     {editingVarId ? 'Update' : 'Add'}
                  </>
                )}
              </Button>
              {editingVarId ? (
                <Button color="grey" className={`btn btn-sm ${styles.Cancelbutton}`} disabled={newVariableLoading} onClick={() => { setEditingVarId(null); setEditingOriginalKey(null); setNewVariableInput(""); }}>
                  Cancel
                </Button>
              ) : null}
            </div>
            
          </div>
        )}
        {!variableMode && (
          <>
            <div style={{ marginTop: "10px" }}>
              <label>Time in SWC</label>
              <Input
                placeholder="Time in SWC"
                value={timeInSWC}
                onChange={(e) => {
                  const value = e.target.value;
                  setTimeInSWC(value);
                }}
              />
              <br />
              <small style={{ color: "orange" }}>
                Sample: If the value is 1, use rate(minute/hour). If the value is greater than 1, use rate(minutes/hours).
              </small>
            </div>
            <div style={{ marginTop: "20px" }}>
              <label style={{ marginRight: "10px" }}>Operation</label>
              <Dropdown
                placeholder="Select Operation"
                selection
                options={[
                  { key: "MERGE", value: "merge", text: "Merge" },
                  { key: "REPLACE", value: "replace", text: "Replace" },
                  { key: "APPEND", value: "append", text: "Append" },
                ]}
                value={operation}
                onChange={(e, { value }) => setOperation(value)}
                style={{ paddingLeft: "1rem" }}
              />
            </div>
          </>
        )}
        <h4>Map Database Columns to Response Keys</h4>
        {editMode
          ? Array.from(databaseColumns).map((column, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <label
                  style={{
                    marginRight: "10px",
                    fontWeight: "600",
                    minWidth: "100px",
                    fontSize: "11px",
                  }}
                >
                  {column}
                </label>
                <Dropdown
                  placeholder={mappings[column] ?? ""}
                  selection
                  options={[
                    { key: "default", text: "Select...", value: "" },
                    ...availableKeys.map((key, index) => ({
                      index,
                      text: key,
                      value: key,
                    })),
                  ]}
                  value={mappings[column] ?? ""}
                  onChange={(e, { value }) => handleMapping(column, value)}
                  className={`${styles.dropdownSmallMenu} ${styles.dropdownScrollBoth}`}
                  style={{ flex: 1, paddingLeft: "0.5rem", fontSize: "11px", paddingTop: "9px", paddingBottom: "9px"}}
                />
                <Input
                  placeholder="Default value" // Corrected typo
                  value={defaultMappings[column] ?? ""} // Corrected state name
                  onChange={(e) => handleDefaultMapping(column, e.target.value)} // Corrected function name
                  style={{ width: "30%", fontSize: "11px" }}
                />
              </div>
            ))
          : ""}
        {variableMode && Array.isArray(variableList) && variableList.length > 0 && (
          <div style={{ marginTop: "16px" }}>
            {(function(){
              const list = Array.isArray(variableList) ? [...variableList] : [];
              // Sort descending by key, but keep PHONE_NUMBER as the last item
              list.sort((a, b) => {
                const ak = String(a?.key_name || a?.key || a?.name || a?.value || a?.text || a?.label || "").toUpperCase();
                const bk = String(b?.key_name || b?.key || b?.name || b?.value || b?.text || b?.label || "").toUpperCase();
                if (ak === 'PHONE_NUMBER' && bk === 'PHONE_NUMBER') return 0;
                if (ak === 'PHONE_NUMBER') return 1; // push a after b
                if (bk === 'PHONE_NUMBER') return -1; // keep b after a
                return bk.localeCompare(ak); // descending
              });
              return list;
            })().map((item, idx) => {
              const varKey = (item?.key_name || item?.key || item?.name || item?.value || item?.text || item?.label || "").toString();
              const display = varKey;
              const selectedMapping = mappings?.[varKey] ?? "";
              const selectedDefault = defaultMappings?.[varKey] ?? "";
              return (
                <div key={idx} style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: "180px" }}>
                    <label style={{ fontWeight: "600", marginLeft: "8px", marginRight: "5px", fontSize: "11px" }}>{display}</label>
                  </div>
                  <Dropdown
                    placeholder={selectedMapping || "Select..."}
                    selection
                    options={(function(){
                      const base = [{ key: "default", text: "Select...", value: "" }];
                      const all = availableKeys.map((key, index) => ({ index, text: key, value: key }));
                      // Restrict only when actively editing a variable (editingVarId set)
                      if (Boolean(editingVarId)) {
                        if (varKey === editingOriginalKey) {
                          const cur = mappings?.[varKey];
                          const curOpt = cur ? [{ index: -1, text: cur, value: cur }] : [];
                          // show default + current + the rest (dedup)
                          const filtered = cur ? all.filter((o) => o.value !== cur) : all;
                          return base.concat(curOpt).concat(filtered);
                        }
                        // Other rows: only default
                        return base;
                      }
                      // Not editing: show full list so after Test all keys are visible
                      return base.concat(all);
                    })()}
                    value={selectedMapping}
                    onChange={(e, { value }) => handleMapping(varKey, value)}
                    className={`${styles.dropdownIconTopFix} ${styles.dropdownSmallMenu} ${styles.dropdownScrollBoth}`}
                    style={{ flex: 1, paddingLeft: "0.5rem", fontSize: "11px", paddingTop: "9px", paddingBottom: "9px"}}
                  />
                  {variableMode && variableMode==true ?null:(
                    <Input
                    placeholder="Default value"
                    value={selectedDefault}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (String(varKey).toUpperCase() === 'PHONE_NUMBER') {
                        const digits = val.replace(/\D/g, '').slice(0, 10);
                        let formatted = '';
                        if (digits.length > 0) {
                          if (digits.length <= 3) {
                            formatted = `(${digits}`;
                          } else if (digits.length <= 6) {
                            formatted = `(${digits.slice(0, 3)})${digits.slice(3)}`;
                          } else {
                            formatted = `(${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6)}`;
                          }
                        }
                        handleDefaultMapping(varKey, formatted);
                        return;
                      }
                      handleDefaultMapping(varKey, val);
                    }}
                    style={{ width: "30%", marginLeft: "10px", fontSize: "11px" }}
                    disabled={String(varKey).toUpperCase() === 'PHONE_NUMBER'}
                    
                   />
                  )}
                  
                  {varKey.toUpperCase() !== "PHONE_NUMBER" ? (
                    <>
                  <button
                      type="button"
                      className="btn btn-icon"
                      title="Edit"
                      onClick={() => { handleStartEditVariable(item); }}
                    >
                      <i className="la la-edit blue" style={{ paddingLeft: "10px" }}></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-icon" style={{width: '13px', marginRight: '6px'}}
                      title="Delete"
                      disabled={editingVarId}
                      onClick={() => { setDeleteTargetRow(item); setDeleteConfirmOpen(true); }}
                    >
                      <i className="la la-trash red" style={{ paddingLeft: "10px" }}></i>
                    </button>
                    </>
                  ) : null}
                </div>
              );
            })}
          </div>
        )}
          
      </div>
    );
  };

  useEffect(() => {
    if (connections !== undefined) {
      let listofdb = connections ?? [];
      console.log("databases updated eeee", connections);
      setDatabases(listofdb);
    }
  }, [connections]);

  // Updated to store headers as an array of objects
  useEffect(() => {
    console.log("database changes", databases);
    if (connections !== undefined && Array.isArray(databases)) {
      let avdb = databases.map((db) => {
        let colm = JSON.parse(db.columns);
        return {
          key: db.id,
          text: db.name,
          value: db.id,
          columns: colm.map((col) => {
            return col.name;
          }), // Columns for Database
        };
      });
      setAvailableDatabases(avdb);
    }
  }, [databases, dbloaderSatus, modalStatus, connections]);

  // Removed auto-fetch from variableDataList on edit; mappings/defaults will be loaded via getVariableApiConnectionList in onEdit

  const handleAuthTypeChange = (e, { value }) => {
    setSelectedAuthType(value);
    setAuthConfig((prev) => ({ ...prev, type: value }));
  };

  // Handle changes for API Key
  const handleKeyChange = (e) => {
    const newKey = e.target.value;
    setAuthConfig((prev) => ({
      ...prev,
      apiKey: { ...prev.apiKey, key: newKey },
    }));
  };

  const handleValueChange = (e) => {
    const value = e.target.value;
    setAuthConfig((prev) => ({
      ...prev,
      apiKey: { ...prev.apiKey, value: value },
    }));
  };

  const handlePlaceChange = (e, { value }) => {
    const place = value; // Corrected from e.target.value
    setAuthConfig((prev) => ({
      ...prev,
      apiKey: { ...prev.apiKey, place: place },
    }));
  };

  // Handle changes for username
  const handleUsernameChange = (e) => {
    const value = e.target?.value;
    setAuthConfig((prev) => ({
      ...prev,
      username: value,
    }));
  };

  // Handle changes for password
  const handlePasswordChange = (e) => {
    const value = e.target?.value;
    setAuthConfig((prev) => ({
      ...prev,
      password: value,
    }));
  };

  // Handle changes for Bearer Token
  const handleTokenChange = (e) => {
    const value = e.target?.value;
    setAuthConfig((prev) => ({
      ...prev,
      token: value,
    }));
  };

  // Create a function to set error message with timeout
  const setErrorMessageWithTimeout = (message, type = "warning") => {
    setErrorMessageType(type);
    setErrorMessage(message);
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
    setTimeout(() => {
      setErrorMessage("");
    }, 5000);
  };

  // Reset form for connection
  const resetCOnnectform = () => {
    setEndpointUrl("");
    setMappings([]);
    setDefaultMappings([]); // Corrected
    setEditInitiated(false);
    setFromNumberCustomValue("");
    setSelectedDatabase("");
    setMethod("get");
    setHeaders([]);
    setSelectedAuthType("none");
    setRawBody("{}");
    setSelectedBodyType("formdata");
    setKeyValuePairs([{ key: "", value: "" }]);
    setAuthConfig({
      id: null,
      endpoint_name: "",
      type: "none",
      username: "",
      password: "",
      token: "",
      apiKey: {
        key: "",
        value: "",
        place: "header",
      },
    });
    setTimeInSWC("");
  };

  // Create URL with search parameters
  function addParamsToUrl(endpoint, params) {
    let paramsname = "";
    params.forEach((param, index) => {
      if (param.key && param.value) {
        paramsname += `${param.key}=${param.value}`;
        if (index < params.length - 1) {
          paramsname += "&";
        }
      }
    });
    if (paramsname != "") {
      endpoint = endpoint.endsWith("/") ? endpoint.slice(0, -1) : endpoint;
      endpoint = endpoint + "?" + paramsname;
    }
    setEndpointUrl(endpoint);
    return endpoint.toString();
  }

  // Function to save data connection
  const handleSaveConnection = () => {
    // Validate endpoint_name
    
    if (!authConfig.endpoint_name || authConfig.endpoint_name.trim() === '') {
      setErrorMessageWithTimeout("Endpoint Name is required!", "error");
      return;
    }

    // Validate endpoint_url
    if (!endpointUrl || endpointUrl.trim() === '') {
      setErrorMessageWithTimeout("Endpoint URL is required!", "error");
      return;
    }

    // Validate URL format
    const urlPattern = /^https?:\/\/.+/;
    if (!urlPattern.test(endpointUrl.trim())) {
      setErrorMessageWithTimeout("Please enter a valid URL starting with http:// or https://", "error");
      return;
    }

    // Variable mode: PHONE_NUMBER must have either mapping (dropdown) or default value
    if (variableMode) {
      const phoneMapVal = (mappings && typeof mappings === 'object') ? (mappings['PHONE_NUMBER'] ?? '') : '';
      const phoneDefaultVal = (defaultMappings && typeof defaultMappings === 'object') ? (defaultMappings['PHONE_NUMBER'] ?? '') : '';
      const isMissing = (!phoneMapVal || String(phoneMapVal).trim() === '') && (!phoneDefaultVal || String(phoneDefaultVal).trim() === '');
      if (isMissing) {
        setErrorMessageWithTimeout("PHONE_NUMBER is required: select a mapping or provide a default value.", "error");
        return;
      }
    }

    if (method == "get") {
      addParamsToUrl(endpointUrl, paramskeyValuePairs);
    }

    const hasFromNumberPlaceholder =
      variableMode && endpointUrl.includes("{{FROM_NUMBER}}");
    const trimmedFromNumber = (fromNumberCustomValue || "").toString().trim();
    // Backend expects these fixed keys for from-number dynamic variable persistence.
    const fixVariable =
      variableMode && hasFromNumberPlaceholder ? "FROM_NUMBER" : "";
    const fixValue =
      variableMode && hasFromNumberPlaceholder ? trimmedFromNumber : "";
    const timestampUrl = processEndpointUrl(endpointUrl);
    // For variable mode, ensure mappings/defaultMappings are keyed by key_name
    let finalMappings = mappings;
    let finalDefaultMappings = defaultMappings;
    if (variableMode && Array.isArray(variableList) && variableList.length > 0) {
      const aliasToKeyName = {};
      variableList.forEach((item) => {
        const keyName = (item?.key_name || item?.key || item?.name || item?.value || item?.text || item?.label || "").toString();
        [item?.key_name, item?.key, item?.name, item?.value, item?.text, item?.label]
          .filter(Boolean)
          .forEach((alias) => {
            aliasToKeyName[String(alias)] = keyName;
          });
      });
      const remapByKeyName = (obj) => {
        const out = {};
        Object.entries(obj || {}).forEach(([k, v]) => {
          const canonical = aliasToKeyName[k] || k;
          out[canonical] = v;
        });
        return out;
      };
      finalMappings = remapByKeyName(mappings);
      finalDefaultMappings = remapByKeyName(defaultMappings);
    }
    // Ensure PHONE_NUMBER key exists for variable mode
    if (variableMode) {
      if (typeof finalMappings?.PHONE_NUMBER === 'undefined') {
        finalMappings = { ...(finalMappings || {}), PHONE_NUMBER: finalMappings?.PHONE_NUMBER ?? "" };
      }
      if (typeof finalDefaultMappings?.PHONE_NUMBER === 'undefined') {
        finalDefaultMappings = { ...(finalDefaultMappings || {}), PHONE_NUMBER: finalDefaultMappings?.PHONE_NUMBER ?? "" };
      }
    }
    const payload = {
      endpointName: authConfig.endpoint_name,
      endpointUrl: timestampUrl,
      displayUrl:
        changeUrl === "Yes" || hasFromNumberPlaceholder ? endpointUrl : null,
      fromNumberCustomValue: trimmedFromNumber,
      from_number_custom_value: trimmedFromNumber, // backend fallback naming
      // Fixed payload keys required by backend to store/reload from-number dynamic variable.
      fix_variable: fixVariable,
      fix_value: fixValue,
      authorization: {
        type: selectedAuthType,
        token:
          headers.find((header) => header.key === "Authorization")?.value || "",
      },
      headers: headers,
      body: {
        type: selectedBodyType,
        data: selectedBodyType === "formdata" || "x-www-form-urlencoded" ? keyValuePairs : rawBody,
      },
      mapping: variableMode ? finalMappings : mappings,
      mappingDefault: variableMode ? finalDefaultMappings : defaultMappings, // Corrected
      method: method,
      authConfig: authConfig,
      selectedDatabase: selectedDatabase,
      timeInSWC: timeInSWC,
      params: paramskeyValuePairs,
      operation: operation,
      availableKeyCopy: availableKeyCopy, // Corrected
      file_configure_type: variableMode ? 'true' : 'false',
    };
    if(variableMode==false){
      // Validate AWS rate format: singular for 1, plural for >1
      const pattern = /^rate\((\d+)\s+(hour|hours|minute|minutes)\)$/;
      const match = timeInSWC.match(pattern);
      if (!match) {
        setErrorMessageWithTimeout("Invalid format of Time in SWC", "error");
        return;
      }
      const number = parseInt(match[1], 10);
      const unit = match[2];
      // Check if singular/plural matches the number
      if (number === 1 && (unit === 'hours' || unit === 'minutes')) {
        setErrorMessageWithTimeout("Invalid format of Time in SWC: Use singular form for 1 (e.g., '1 minute' or '1 hour')", "error");
        return;
      }
      if (number > 1 && (unit === 'hour' || unit === 'minute')) {
        setErrorMessageWithTimeout("Invalid format of Time in SWC: Use plural form for numbers greater than 1 (e.g., '5 minutes' or '24 hours')", "error");
        return;
      }
  }
    setAvailableKeyCopy({}); // Corrected
    setEditMod(false);

    if (authConfig?.id == null) {
      setConloaderStatus(true);
      dataconnection.addDataApiConnection(payload).then((res) => {
        let st = res?.status ?? "";
        if (st == "success") {
          loadToolApiendpoint();
          // notify listing to re-enable delete buttons
          setListEditingResetTick((p) => p + 1);
          // After final submit, reset mapping section but keep PHONE_NUMBER row visible
          if (variableMode) {
            setMappings({});
            setDefaultMappings((prev) => ({ PHONE_NUMBER: (prev?.PHONE_NUMBER ?? "PHONE_NUMBER") }));
            setEditMod(false);
            setVariableList([{ key_name: 'PHONE_NUMBER' }]);
            setAvailableKeys([]);
            setNewVariableInput("");
            setEditingVarId && setEditingVarId(null);
            setEditingOriginalKey && setEditingOriginalKey(null);
          }
          resetCOnnectform();
          setChangeUrl("No");
          setErrorMessageWithTimeout(
            res?.message ?? "Data added successfully.",
            res.status ?? "success"
          );
        } else {
          let error_list = res?.errors ?? {};
          setChangeUrl("No");
          setErrorMessageWithTimeout(
            res?.message ?? "All form data must be filled!",
            res.status
          );
        }
        setConloaderStatus(false);
      });
    } else {
      dataconnection
        .editDataApiConnection(authConfig?.id, payload)
        .then((res) => {
          if (res) {
            setErrorMessageWithTimeout(
              res?.message ?? "Data modified successfully.",
              res.status
            );
            loadToolApiendpoint();
            // notify listing to re-enable delete buttons
            setListEditingResetTick((p) => p + 1);
            // After final submit, reset mapping section but keep PHONE_NUMBER row visible
            if (variableMode) {
              setMappings({});
              setDefaultMappings((prev) => ({ PHONE_NUMBER: (prev?.PHONE_NUMBER ?? "PHONE_NUMBER") }));
              setEditMod(false);
              setVariableList([{ key_name: 'PHONE_NUMBER' }]);
              setAvailableKeys([]);
              setNewVariableInput("");
              setEditingVarId && setEditingVarId(null);
              setEditingOriginalKey && setEditingOriginalKey(null);
            }
            resetCOnnectform();
            setConloaderStatus(false);
          } else {
            setErrorMessageWithTimeout(
              "Please refresh page and try again",
              "error"
            );
            setConloaderStatus(false);
          }
        });
    }

  };

  // Render auth fields
  const renderAuthFields = () => {
    return (
      <div style={{ minHeight: "160px" }}>
        {selectedAuthType === "none" && (
          <p>
            The authorization header will be automatically generated when you send
            the request.
          </p>
        )}
        {selectedAuthType === "basic" && (
          <>
            <Form.Field>
              <label>Username</label>
              <Input
                placeholder="Enter Username"
                value={authConfig.username}
                onChange={handleUsernameChange}
              />
            </Form.Field>
            <Form.Field>
              <label>Password</label>
              <Input
                placeholder="Enter Password"
                type="password"
                value={authConfig.password}
                onChange={handlePasswordChange}
              />
            </Form.Field>
          </>
        )}
        {selectedAuthType === "bearer" && (
          <Form.Field>
            <label>Bearer Token</label>
            <Input
              placeholder="Enter Bearer Token"
              value={authConfig?.token}
              onChange={handleTokenChange}
            />
          </Form.Field>
        )}
        {selectedAuthType === "apikey" && (
          <>
            <Form.Field>
              <label>Key</label>
              <Input
                placeholder="Enter API Key"
                value={authConfig.apiKey.key}
                onChange={handleKeyChange}
              />
            </Form.Field>
            <Form.Field>
              <label>Value</label>
              <Input
                placeholder="Enter Value"
                value={authConfig.apiKey.value}
                onChange={handleValueChange}
              />
            </Form.Field>
            <Form.Field>
              <label>Place</label>
              <Dropdown
                placeholder="Select Place"
                fluid
                selection
                options={[
                  { key: "header", value: "header", text: "Header" },
                  { key: "param", value: "param", text: "Param" },
                ]}
                value={authConfig.apiKey.place} // Corrected from type to place
                onChange={handlePlaceChange}
                className={styles.placeDividerFix}
              />
            </Form.Field>
          </>
        )}
      </div>
    );
  };

  const handleConvertToJson = (txt) => {
    try {
      setTimeout(() => {
        const jsonString = JSON.stringify(txt, null, 2); // Pretty print
        return jsonString;
      }, 0); // Defer to next event loop
    } catch (err) {
      return "Failed to convert log data to JSON";
    }
  };

  const renderResponsePanel = () => (
    <div>
      {responseOutput ? (
        <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
          <Form.Field>
            <textarea
              readOnly
              style={{ height: "250px", width: "100%", resize: "vertical" }}
              value={JSON.stringify(responseOutput, undefined, 4)}
              id="resposeoutput"
            ></textarea>
          </Form.Field>
        </pre>
      ) : (
        <p>No response available. Click "Test" to fetch data.</p>
      )}
    </div>
  );

  const handleAddKeyValuePair = () => {
    const pairs = Array.isArray(keyValuePairs) ? keyValuePairs : [];
    setKeyValuePairs([...pairs, { key: "", value: "" }]);
  };

  // Remove Key-Value Pair
  const handleRemoveKeyValuePair = (index) => {
    const pairs = Array.isArray(keyValuePairs) ? keyValuePairs : [];
    setKeyValuePairs(pairs.filter((_, i) => i !== index));
  };

  // Update Key-Value Pair
  const handleKeyValueChange = (index, field, value) => {
    const pairs = Array.isArray(keyValuePairs) ? keyValuePairs : [];
    const updatedPairs = pairs.map((pair, i) =>
      i === index ? { ...pair, [field]: value } : pair
    );
    setKeyValuePairs(updatedPairs);
  };

  // Render Body Panel
  const renderBodyPanel = () => (
    <div>
      <Form>
        <Form.Field>
          <label>Body Type</label>
          <Form.Group>
            <Form.Radio
              label="Form Data"
              value="formdata"
              checked={selectedBodyType === "formdata"}
              onChange={(e, { value }) => setSelectedBodyType(value)}
            />
            <Form.Radio
              label="x-www-form-urlencoded"
              value="x-www-form-urlencoded"
              checked={selectedBodyType === "x-www-form-urlencoded"}
              onChange={(e, { value }) => setSelectedBodyType(value)}
            />
            <Form.Radio
              label="Raw"
              value="raw"
              checked={selectedBodyType === "raw"}
              onChange={(e, { value }) => setSelectedBodyType(value)}
            />
          </Form.Group>
        </Form.Field>

        {selectedBodyType === "raw" && (
          <Form.Field>
            <label>Raw JSON</label>
            <textarea
              placeholder="Enter JSON"
              style={{ height: "150px", width: "100%", resize: "vertical" }}
              value={rawBody}
              onChange={(e) => {
                const inputValue = e.target.value;
                setRawBody(inputValue);
                try {
                  JSON.parse(inputValue); // Validate JSON
                } catch {
                  console.error("Invalid JSON");
                }
              }}
            />
          </Form.Field>
        )}

        {(selectedBodyType === "formdata" ||
          selectedBodyType === "x-www-form-urlencoded") && (
          <Form.Field>
            <label>Key-Value Pairs</label>
            {renderKeyValuePairs()}
          </Form.Field>
        )}
      </Form>
    </div>
  );

  // Render Key-Value Pairs
  const renderKeyValuePairs = () => {
    const pairs = Array.isArray(keyValuePairs) ? keyValuePairs : [];
    return (
      <>
        {/* Compact headers */}
        <div style={{ display: "flex", alignItems: "center", fontSize: "12px", color: "#6b7280", marginBottom: "6px" }}>
          <div style={{ flex: 1, paddingLeft: "2px" }}>Key</div>
          <div style={{ flex: 1, paddingLeft: "2px" }}>Value</div>
          
        </div>
        {pairs.map((pair, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "8px",
              padding: "0px",
              borderRadius: "6px",
            }}
          >
            <Input
              placeholder="Key"
              value={pair.key}
              onChange={(e) => handleKeyValueChange(index, "key", e.target.value)}
              style={{ flex: 1 }}
              size="small"
            />
            <Input
              placeholder="Value"
              value={pair.value}
              onChange={(e) => handleKeyValueChange(index, "value", e.target.value)}
              style={{ flex: 1 }}
              size="small"
            />
            {pairs.length > 1 && (
              <Button
                icon="minus"
                color="red"
                onClick={() => handleRemoveKeyValuePair(index)}
                style={{ width: "36px", padding: "9px" }}
                title="Remove"
              />
            )}
          </div>
        ))}
        <Button icon="plus" color="green" onClick={handleAddKeyValuePair} style={{ width: "10%", padding: "8px", fontWeight: 600, float: "right" }} />
    </>
    );
  };

  function extractKeysFromResponseForSheet(response) {
    let copy = {};
    let count = 0;
    for (const element of response.values[0]) {
      copy[element] = count;
      count++;
    }
    setAvailableKeyCopy(copy); // Corrected
    return response.values[0];
  }

  const calculateTimestamp = (operation, value, unit) => {
    const now = new Date();
    let timestamp;

    switch (operation) {
      case "PLUS":
        if (unit === "DAY") {
          timestamp = new Date(now.getTime() + value * 24 * 60 * 60 * 1000);
        } else if (unit === "MINUTE") {
          timestamp = new Date(now.getTime() + value * 60 * 1000);
        } else if (unit === "MONTH") {
          timestamp = new Date(now.setMonth(now.getMonth() + value));
        }
        break;
      case "MINUS":
        if (unit === "DAY") {
          timestamp = new Date(now.getTime() - value * 24 * 60 * 60 * 1000);
        } else if (unit === "MINUTE") {
          timestamp = new Date(now.getTime() - value * 60 * 1000);
        } else if (unit === "MONTH") {
          timestamp = new Date(now.setMonth(now.getMonth() - value));
        }
        break;
      default:
        timestamp = now; // Default to current time
    }
    return Math.floor(timestamp.getTime() / 1000);
  };

  const parseTimestampPlaceholder = (placeholder) => {
    const parts = placeholder.split("_");
    if (parts.length < 4) return null;

    const unit = parts[parts.length - 1];
    const value = parseInt(parts[parts.length - 2], 10);
    const operation = parts[parts.length - 3];
    const base = parts.slice(0, parts.length - 3).join("_");

    if (!["NOW", "CURRENT_TIMESTAMP"].includes(base)) return null;
    if (!["PLUS", "MINUS"].includes(operation)) return null;
    if (!Number.isFinite(value)) return null;

    return { base, operation, value, unit };
  };

  const processEndpointUrl = (url) => {
    const regex = /{{(.*?)}}/g;
    let match;
    let processedUrl = url;
    let hasTimestampReplacement = false;

    // Substitute FROM_NUMBER with custom value for requests, while keeping placeholder visible in UI
    if (
      variableMode &&
      fromNumberCustomValue &&
      fromNumberCustomValue.toString().trim() !== "" &&
      processedUrl.includes("{{FROM_NUMBER}}")
    ) {
      processedUrl = processedUrl.replace(
        /{{FROM_NUMBER}}/g,
        fromNumberCustomValue.toString().trim()
      );
    }

    while ((match = regex.exec(url)) !== null) {
      const placeholder = match[1];
      const parsed = parseTimestampPlaceholder(placeholder);

      if (!parsed) continue;

      const { operation, value, unit } = parsed;
      const timestamp = calculateTimestamp(operation, value, unit);

      processedUrl = processedUrl.replace(`{{${placeholder}}}`, timestamp);
      hasTimestampReplacement = true;
    }

    setChangeUrl(hasTimestampReplacement ? "Yes" : "No");
    return processedUrl;
  };

  // Function to hit the API
  const handleTestEndpoint = async () => {
    if (!endpointUrl) {
      setErrorMessageWithTimeout("Please enter a valid Endpoint URL.");
      return;
    }

    let backupendpointUrl = endpointUrl;
    try {
      let newEndpointUrl = addParamsToUrl(endpointUrl, paramskeyValuePairs)
      const processedUrl = processEndpointUrl(newEndpointUrl);

      let requestData = {
        endpointUrl: processedUrl,
        method: method,
        headers,
        authConfig: authConfig,
        selectedAuthType: selectedAuthType,
        bodyType: selectedBodyType,
        bodyData: keyValuePairs,
        params: paramskeyValuePairs,
        rawBody: rawBody ?? "{}",
        // Keep backend parity with save/update for from-number dynamic variable.
        fix_variable:
          variableMode && processedUrl.includes("{{FROM_NUMBER}}")
            ? "FROM_NUMBER"
            : "",
        fix_value:
          variableMode && processedUrl.includes("{{FROM_NUMBER}}")
            ? (fromNumberCustomValue || "").toString().trim()
            : "",
      };
      const requestHeaders = {};
      if (selectedAuthType === "basic") {
        const authToken = btoa(`${authConfig.username}:${authConfig.password}`);
        requestHeaders["Authorization"] = `Basic ${authToken}`;
      } else if (selectedAuthType === "bearer") {
        requestHeaders["Authorization"] = `Bearer ${authConfig.token}`;
      } else if (
        selectedAuthType === "apikey" &&
        authConfig.apiKey.place === "header"
      ) {
        requestHeaders[authConfig.apiKey.key] = authConfig.apiKey.value;
      }

      headers.forEach(({ key, value }) => {
        if (key && value) {
          requestHeaders[key] = value;
        }
      });

      let requestBody = null;
      const urlencoded = new URLSearchParams();

      if (method === "get") {
        setEndpointUrl(addParamsToUrl(endpointUrl, paramskeyValuePairs));
      }

      dataconnection.testRequest(requestData).then((res) => {
        if (res.status) {
          // If API returns a token (e.g., ServiceTitan), capture it into Bearer token field
          const returnedToken = res?.token || res?.data?.token;
          if (returnedToken) {
            setAuthConfig((prev) => ({
              ...prev,
              token: returnedToken,
            }));
            if (selectedAuthType !== "bearer") {
              setSelectedAuthType("bearer");
            }
          }
          setResponseOutput(res.data);
          setEndpointUrl(backupendpointUrl);
          setActiveTab("responses");
          let extractedKeys = [];
          if (endpointUrl.includes("sheets.googleapis.com")) {
            extractedKeys = extractKeysFromResponseForSheet(res.data);
          } else {
            const firstValidValue = Object.values(res.data).find(
              (val) => Array.isArray(val) && val.length > 0
            );
            extractedKeys = extractKeysFromResponse(firstValidValue ?? []);
          }
          extractedKeys = [...new Set(extractedKeys)];
          setEditMod(true);
          setAvailableKeys(extractedKeys);
        } else {
          setActiveTab("responses");
          setResponseOutput(res.message);
          setEndpointUrl(backupendpointUrl);
        }
      });
    } catch (error) {
      console.log(error);
      setActiveTab("responses 2");
      setResponseOutput(error.response || { error: error.message });
      setEndpointUrl(backupendpointUrl);
    }
  };

  // Render header management section
  const renderHeaderManagement = () => (
    <div>
      <h4>Manage Headers</h4>
      {/* Compact headers */}
      <div style={{ display: "flex", alignItems: "center", fontSize: "12px", color: "#6b7280", marginBottom: "6px" }}>
        <div style={{ flex: 1, paddingLeft: "2px" }}>Key</div>
        <div style={{ flex: 1, paddingLeft: "2px" }}>Value</div>
        <div style={{ width: "40px", textAlign: "right" }}></div>
      </div>
      {headers.map((header, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "8px",
            padding: "0px",
            borderRadius: "6px",
          }}
        >
          <Input
            placeholder="Key"
            value={header.key}
            onChange={(e) => handleHeaderChange(index, "key", e.target.value)}
            style={{ flex: 1 }}
            size="small"
          />
          <Input
            placeholder="Value"
            value={header.value}
            onChange={(e) => handleHeaderChange(index, "value", e.target.value)}
            style={{ flex: 1 }}
            size="small"
          />
          <Button
            icon="minus"
            color="red"
            onClick={() => handleRemoveHeader(index)}
            style={{ width: "36px", padding: "9px" }}
            title="Remove"
          />
        </div>
      ))}
      <Button
        icon="plus"
        color="green"
        onClick={handleAddHeader}
        style={{ width: "10%", padding: "8px", fontWeight: 600, float: "right" }}
      />
      <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "6px" }}>
        Tip: Use headers for auth and custom metadata.
      </div>
    </div>
  );

  const setmodalStatusandcleardata = (status) => {
    setmodalStatus(status);
    setinitFormdata({});
  };

  // Header management
  const handleAddHeader = (type = "header") => {
    if (type === "params") {
      setParamKeyValuePairs([...paramskeyValuePairs, { key: "", value: "" }]);
    } else {
      setHeaders([...headers, { key: "", value: "" }]);
    }
  };

  const handleRemoveHeader = (index, type = "header") => {
    if (type === "params") {
      setParamKeyValuePairs(paramskeyValuePairs.filter((_, i) => i !== index));
    } else {
      setHeaders(headers.filter((_, i) => i !== index));
    }
  };

  const handleHeaderChange = (index, field, value, type = "header") => {
    if (type === "params") {
      const updatedHeaders = paramskeyValuePairs.map((header, i) =>
        i === index ? { ...header, [field]: value } : header
      );
      setParamKeyValuePairs(updatedHeaders);
    } else {
      const updatedHeaders = headers.map((header, i) =>
        i === index ? { ...header, [field]: value } : header
      );
      setHeaders(updatedHeaders);
    }
  };

  const panes = [
    {
      menuItem: (
        <Menu.Item
          key="params"
          className={
            activeTab === "params" ? styles.menuActiveDataconnection : ""
          }
          onClick={() => setActiveTab("params")}
        >
          Params
        </Menu.Item>
      ),
      render: () => (
        <Tab.Pane>
          <div>
            <h4>Manage Params</h4>
            <div style={{ display: "flex", alignItems: "center", fontSize: "12px", color: "#6b7280", marginBottom: "6px" }}>
              <div style={{ flex: 1, paddingLeft: "2px" }}>Key</div>
              <div style={{ flex: 1, paddingLeft: "2px" }}>Value</div>
              
            </div>
            {paramskeyValuePairs.map((header, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "8px",
                  padding: "0px",
                  borderRadius: "6px",
                }}
              >
                <Input
                  placeholder="Key"
                  value={header.key}
                  onChange={(e) =>
                    handleHeaderChange(index, "key", e.target.value, "params")
                  }
                  style={{ flex: 1 }}
                  size="small"
                />
                <Input
                  placeholder="Value"
                  value={header.value}
                  onChange={(e) =>
                    handleHeaderChange(index, "value", e.target.value, "params")
                  }
                  style={{ flex: 1 }}
                  size="small"
                />
                <Button
                  icon="minus"
                  color="red"
                  onClick={() => handleRemoveHeader(index, "params")}
                  style={{ width: "36px", padding: "9px" }}
                  title="Remove"
                />
              </div>
            ))}
            <Button
              icon="plus"
              color="green"
              onClick={() => handleAddHeader("params")}
              style={{ width: "10%", padding: "8px", fontWeight: 600, float: "right" }}
            />
            <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "6px" }}>
              Tip: Use params for GET requests. For other methods, prefer Body.
            </div>
          </div>
        </Tab.Pane>
      ),
    },
    {
      menuItem: (
        <Menu.Item
          key="authorization"
          className={
            activeTab === "authorization" ? styles.menuActiveDataconnection : ""
          }
          onClick={() => setActiveTab("authorization")}
        >
          Authorization
        </Menu.Item>
      ),
      render: () => (
        <Tab.Pane>
          <Form>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  width: "40%",
                  borderRight: "1px solid rgb(190 202 213)",
                  paddingRight: "10px",
                }}
              >
                <Form.Field>
                  <label>Auth Type</label>
                  <Dropdown
                    placeholder="Select Auth Type"
                    fluid
                    selection
                    options={authOptions}
                    onChange={handleAuthTypeChange}
                    value={selectedAuthType}
                    style={{ paddingLeft: "1rem" }}
                  />
                </Form.Field>
              </div>
              <div style={{ width: "55%" }}>{renderAuthFields()}</div>
            </div>
          </Form>
        </Tab.Pane>
      ),
    },
    {
      menuItem: (
        <Menu.Item
          key="headers"
          onClick={() => setActiveTab("headers")}
          className={
            activeTab === "headers" ? styles.menuActiveDataconnection : ""
          }
        >
          Headers
        </Menu.Item>
      ),
      render: () => <Tab.Pane>{renderHeaderManagement()}</Tab.Pane>,
    },
    {
      menuItem: (
        <Menu.Item
          key="body"
          className={
            activeTab === "body" ? styles.menuActiveDataconnection : ""
          }
          onClick={() => setActiveTab("body")}
        >
          Body
        </Menu.Item>
      ),
      render: () => <Tab.Pane>{renderBodyPanel()}</Tab.Pane>,
    },
    {
      menuItem: (
        <Menu.Item
          key="responses"
          onClick={() => setActiveTab("responses")}
          className={
            activeTab === "responses" ? styles.menuActiveDataconnection : ""
          }
        >
          Responses
        </Menu.Item>
      ),
      render: () => <Tab.Pane>{renderResponsePanel()}</Tab.Pane>,
    },
    {
      menuItem: (
        <Menu.Item
          key="settings"
          onClick={() => setActiveTab("settings")}
          className={
            activeTab === "settings" ? styles.menuActiveDataconnection : ""
          }
        >
          Settings
        </Menu.Item>
      ),
      render: () => (
        <Tab.Pane>
          {!variableMode && renderDatabaseSelection(selectedDatabase, handleDatabaseChange)}
          {renderSettingsItems(
            databaseColumns,
            availableKeys,
            handleMapping,
            mappings,
            defaultMappings, // Corrected
            handleDefaultMapping // Corrected
          )}
        </Tab.Pane>
      ),
    },
  ];

  const onEditApiEndpont = (apicon) => {

    if (variableMode) {
      setMappings({});
      setDefaultMappings({});
      setEditMod(false);
      setVariableList([]);
      setAvailableKeys([]);
      setNewVariableInput("");
      setEditingVarId && setEditingVarId(null);
      setEditingOriginalKey && setEditingOriginalKey(null);
    }
    
    setActiveTab("settings");
    setResponseOutput(null);
    setEditInitiated(true);
    let operation = apicon.operation ?? "";
    setOperation(operation);
    const uiDisplayUrl =
      apicon.displayUrl ?? apicon.display_url ?? apicon.endpoint_url ?? "";
    const hasFromNumberInUrl =
      variableMode &&
      typeof uiDisplayUrl === "string" &&
      uiDisplayUrl.includes("{{FROM_NUMBER}}");
    let endpoint_url = uiDisplayUrl || "";

    let mapping = apicon.mapping ?? "";
    let defaultMapping = apicon.mappingDefault ?? "";
    // Restore previously saved FROM_NUMBER custom value so edit shows both the variable and its saved number.
    if (variableMode) {
      const savedFromNumber =
        apicon.fromNumberCustomValue ??
        apicon.from_number_custom_value ??
        apicon.fix_value ??
        "";
      const savedFromNumberStr = savedFromNumber?.toString() || "";

      // If backend provided fixed variable/value, prefer that for preselect and URL normalization.
      const fixedVar =
        apicon.fix_variable ?? apicon.fixVariable ?? apicon.fix_var ?? "";
      const fixedVal = savedFromNumberStr;

      if (fixedVar === "FROM_NUMBER" && fixedVal.trim() !== "") {
        let nextUrl = endpoint_url || "";
        if (nextUrl && !nextUrl.includes("{{FROM_NUMBER}}")) {
          // Try to swap the fixed value with the placeholder so URL stays dynamic during edit.
          const escapedVal = fixedVal.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          const re = new RegExp(escapedVal);
          if (re.test(nextUrl)) {
            nextUrl = nextUrl.replace(re, "{{FROM_NUMBER}}");
          }
        }
        endpoint_url = nextUrl;
        setDropdownValue("FROM_NUMBER");
        setFromNumberCustomValue(fixedVal);
        setCustomValue(fixedVal);
      } else {
        // Fallback to previously saved value keys
        setFromNumberCustomValue(savedFromNumberStr);
        setCustomValue(savedFromNumberStr);
        if (hasFromNumberInUrl || savedFromNumberStr.trim() !== "") {
          setDropdownValue("FROM_NUMBER");
        }
      }
    }

    setEndpointUrl(endpoint_url);
    
    if (mapping) {
      setEditMod(true);
    }

    console.log("mapping",mapping);
    console.log("defaultMapping",defaultMapping);

    setMappings(mapping || {});
    setDefaultMappings(defaultMapping || {}); // Corrected
    if (variableMode) {
      const mapKeys = new Set([
        ...Object.keys(mapping || {}),
        ...Object.keys(defaultMapping || {}),
      ]);
      dataconnection.variableDataList(apicon.id).then((res) => {
        const raw = (res && res.data) ? res.data : res;
        const allVars = Array.isArray(raw) ? raw : [];
        const selected = allVars.filter((item) => {
          const name = (item && (item.key_name || item.key || item.name || item.value || item.text || item.label)) || '';
          return mapKeys.has(name);
        });
        // Dedupe by key (case-insensitive)
        const seen = new Set();
        let unique = selected.filter((item) => {
          const key = String(item?.key_name || item?.key || item?.name || item?.value || item?.text || item?.label || '').toUpperCase();
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        // Ensure PHONE_NUMBER row persists if it exists in mapping/mappingDefault
        const hasPhoneInMap = Object.prototype.hasOwnProperty.call(mapping || {}, 'PHONE_NUMBER') || Object.prototype.hasOwnProperty.call(defaultMapping || {}, 'PHONE_NUMBER');
        const hasPhoneInList = unique.some((it) => String(it?.key_name || it?.key || it?.name || it?.value || it?.text || it?.label || '').toUpperCase() === 'PHONE_NUMBER');
        if (hasPhoneInMap && !hasPhoneInList) {
          unique = [...unique, { key_name: 'PHONE_NUMBER' }];
        }
        setVariableList(unique);
        setEditMod(true);
      }).catch(() => {
        setEditMod(true);
      });
    }
    setSelectedDatabase(apicon.selectedDatabase ?? "");

    const selectedDb = availableDatabases.find(
      (db) => db.value === apicon.selectedDatabase
    );
    setDatabaseColumns(selectedDb ? selectedDb.columns : databaseColumns);

    let method = apicon.method ?? "get";
    setMethod(method);
    let headers = apicon.headers ?? [];
    setHeaders(headers);
    const typeCandidate = apicon?.authorization_type ?? apicon?.authConfig?.type ?? apicon?.type ?? "none";
    const normalizedType = normalizeAuthType(typeCandidate);
    let params = apicon.params ?? [];
    setParamKeyValuePairs(params);

    setSelectedAuthType(normalizedType);
    if (apicon.body) {
      setSelectedBodyType(apicon.body.type || "formdata");
      if (apicon.body.type === "raw") {
        try {
          const parsedData = JSON.parse(apicon.body.data || "{}");
          setRawBody(JSON.stringify(parsedData, null, 2));
        } catch (error) {
          console.error("Invalid JSON in raw body data", error);
        }
      } else if (
        apicon.body.type === "formdata" ||
        apicon.body.type === "x-www-form-urlencoded"
      ) {
        const keyValuePairs = apicon.body.data;
        console.log("keyValuePairs",keyValuePairs);
        setKeyValuePairs(keyValuePairs);
      }
    }
    let mergedAuth = {
      ...authConfig,
      ...(apicon?.authConfig || {}),
      id: apicon.id,
      endpoint_name: apicon.endpoint_name ?? '',
      type: normalizedType,
    };
    // Overlay from top-level if present (avoid overwriting with null/undefined/empty)
    if (typeof apicon?.username !== 'undefined' && apicon.username !== null && apicon.username !== "") {
      mergedAuth.username = apicon.username;
    }
    if (typeof apicon?.password !== 'undefined' && apicon.password !== null && apicon.password !== "") {
      mergedAuth.password = apicon.password;
    }
    if (typeof apicon?.token !== 'undefined' && apicon.token !== null && apicon.token !== "") {
      mergedAuth.token = apicon.token;
    }
    if (apicon?.apiKey && typeof apicon.apiKey === 'object') {
      mergedAuth.apiKey = {
        ...(mergedAuth.apiKey || { key: "", value: "", place: "header" }),
        ...apicon.apiKey,
      };
    }
    // If Bearer and token still empty, try to derive from Authorization header
    if (normalizedType === "bearer" && (!mergedAuth.token || mergedAuth.token === "")) {
      const authHeader = (headers || []).find((h) => String(h?.key || "").toLowerCase() === "authorization")?.value;
      if (authHeader) {
        const m = String(authHeader).match(/^Bearer\s+(.+)$/i);
        mergedAuth.token = m ? m[1] : authHeader;
      }
    }
    setAuthConfig(mergedAuth);
    setTimeInSWC(apicon?.timeInSWC ?? "");
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const buttonStyle = {
    background: "linear-gradient(90deg,rgb(241, 241, 241),rgb(212, 212, 212))",
    boxShadow: "0px 4px 8px #b3b3b3",
    borderRadius: "5px",
    color: "#333",
    display: "inline-block",
    fontSize: "16px",
    padding: "2px",
    textDecoration: "none",
    minWidth: "80px",
    border: 0,
  };

  return (
    <>
      <div ref={topRef}>
        <DataProvider>
          {showConnectionform && (
            <>
              {errorMessage &&
                (errorMessageType === "warning" ||
                errorMessageType === "error" ? (
                  <Message error>
                    <Message.Header>Validation Error</Message.Header>
                    <p>{errorMessage}</p>
                  </Message>
                ) : (
                  <Message success>
                    <Message.Header>Success message</Message.Header>
                    <p>{errorMessage}</p>
                  </Message>
                ))}
              <div style={{ marginTop: "3rem" }}>
                <Form>
                  <Form.Field>
                    <Grid columns={2} stackable>
                      <label style={{ width: "30%" }}>Endpoint Name</label>
                      <Input
                        style={{ width: "69%" }}
                        placeholder="Endpoint name"
                        value={authConfig.endpoint_name}
                        onChange={(e) =>
                          setAuthConfig({
                            ...authConfig,
                            endpoint_name: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </Form.Field>
                  <Form.Field>
                    <Grid columns={2} stackable style={{ marginTop: "2rem" }}>
                      <label style={{ width: "30%" }}>Endpoint URL</label>
                      <Input
                        placeholder="https://www.example.com"
                        ref={inputRef}
                        value={endpointUrl}
                        onChange={(e) => setEndpointUrl(e.target.value)}
                        onDoubleClick={getSelectedText}
                        style={{ width: "69%" }}
                        action={{
                          content: "Test",
                          color: "blue",
                          className: "btn linear-gradient",
                          style: { width: "15%", display: "block" },
                          onClick: handleTestEndpoint,
                        }}
                        label={
                          <Dropdown
                            placeholder="GET"
                            options={[
                              { key: "get", text: "GET", value: "get" },
                              { key: "post", text: "POST", value: "post" },
                              // { key: "put", text: "PUT", value: "put" },
                              // {
                              //   key: "delete",
                              //   text: "DELETE",
                              //   value: "delete",
                              // },
                              // { key: "patch", text: "PATCH", value: "patch" },
                            ]}
                            value={method}
                            onChange={(e, data) => {
                              const selectedValue = data.value;
                              setMethod(selectedValue);
                            }}
                            selection
                            style={{
                              minWidth: "80px",
                              width: "15%",
                              paddingLeft: "1rem",
                            }}
                          />
                        }
                        labelPosition="left"
                      />
                    </Grid>
                  </Form.Field>
                  {modalOpen && (
                    <div className="bg-white p-6 rounded-md w-96">
                      <h3 className="text-lg font-semibold mb-4">
                        Replace Selected Text
                      </h3>
                      <p className="mb-2">
                        Selected:{" "}
                        <span className="font-medium">"{selectedText}"</span>
                      </p>
                      <div className="d-flex gap-3">
                        <select
                          value={dropdownValue}
                          onChange={(e) => setDropdownValue(e.target.value)}
                          className="w-full p-2 border rounded-md mb-4"
                        >
                          <option value="" disabled>
                            Select a variable
                          </option>
                          {(variableMode
                            ? variableOptions
                            : variableOptions.filter(
                                (opt) => opt.value !== "FROM_NUMBER"
                              )
                          ).map((option) => (
                            <option key={option.key} value={option.value}>
                              {option.text}
                            </option>
                          ))}
                        </select>
                        <input
                          type="number"
                          disabled={
                            dropdownValue !== "NOW" &&
                            dropdownValue !== "FROM_NUMBER"
                          }
                          placeholder={
                            dropdownValue === "FROM_NUMBER"
                              ? "Enter from number"
                              : "Enter custom value"
                          }
                          value={customValue}
                          onChange={(e) => setCustomValue(e.target.value)}
                          className={`w-full p-2 border rounded-md mb-4 ${
                            dropdownValue !== "NOW" &&
                            dropdownValue !== "FROM_NUMBER"
                              ? "bg-gray-100 cursor-not-allowed"
                              : ""
                          }`}
                          style={{
                            display:
                              variableMode || dropdownValue === "NOW"
                                ? "block"
                                : "none",
                          }}
                        />
                        <select
                          value={timeUnit}
                          disabled={dropdownValue !== "NOW"}
                          onChange={(e) => setTimeUnit(e.target.value)}
                          className={`w-full p-2 border rounded-md mb-4 ${
                            dropdownValue !== "NOW"
                              ? "bg-gray-100 cursor-not-allowed"
                              : ""
                          }`}
                        >
                          <option value="" disabled>
                            Select a time unit
                          </option>
                          {timeUnitOptions.map((option) => (
                            <option key={option.key} value={option.value}>
                              {option.text}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="d-flex justify-end gap-2">
                        <button
                          onClick={() => {
                            setModalOpen(false);
                            setDropdownValue("");
                            setSelectedText("");
                            setCustomValue("");
                            setTimeUnit("");
                          }}
                          className="btn-sm yr-btn-small"
                          style={buttonStyle}
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleReplace}
                          className="btn linear-gradient yr-submitbtn btn-sm"
                          style={{ marginLeft: "10px" }}
                        >
                          Replace
                        </button>
                      </div>
                    </div>
                  )}
                </Form>
                <Tab
                  panes={panes}
                  style={{ marginTop: "2rem" }}
                  activeIndex={panes.findIndex(
                    (pane) => pane.menuItem.key === activeTab
                  )}
                />
              </div>
            </>
          )}
          {modalStatus && (
            <DataLayerModal
              open={modalStatus}
              onClose={() => setmodalStatus(false)}
              onOpen={() => setmodalStatus(true)}
              setDatabases={setDatabases}
              initFormdata={{ ...initFormdata }}
              selectedDatabase={selectedDatabase}
              setinitFormdata={setinitFormdata}
              loading={dbloaderSatus}
              setLoading={setDbloaderStatusp}
            />
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "16px",
              width: "100%",
              paddingRight: "0",
            }}
          >
            <button
              className={`btn linear-gradient yr-submitbtn btn-sm ${styles.button}`}
              onClick={() => {
                handleSaveConnection();
              }}
              disabled={editingVarId}
            >
              Save New Connection
            </button>
          </div>

          <div style={{ marginTop: "2rem" }}>
            <button className={`${styles.linkButton}`}>
              {variableMode ? "Variable Data Listing" : "Data Layer Listing"}
            </button>
            <ConnectionList
              onEdit={onEditApiEndpont}
              toolapiendpoint={toolapiendpoint}
              loadToolApiendpoint={loadToolApiendpoint}
              conloaderSatus={conloaderSatus}
              setConloaderStatus={setConloaderStatus}
              resetCOnnectform={resetCOnnectform}
              variableMode={variableMode}
              listEditingResetTick={listEditingResetTick}
            />
          </div>
          {!variableMode && (
          <div
            style={{ marginTop: "2rem" }}
            className={`${styles.datalayerTable}`}
          >
            
              <a
                onClick={() => {
                  setmodalStatusandcleardata(!modalStatus);
                }}
              >
                <button className={`${styles.linkButton}`}>
                  <i className="fas fa-plus"></i>
                  Add new data connection
                </button>
              </a>
           

            <DatabaseListing
              databases={databases}
              open={modalStatus}
              onClose={() => setmodalStatus(false)}
              onOpen={() => setmodalStatus(true)}
              setDatabases={setDatabases}
              setinitFormdata={setinitFormdata}
              loading={dbloaderSatus}
              setLoading={setDbloaderStatus}
            />
            </div>
          )}
        </DataProvider>
      </div>
      <Modal open={deleteConfirmOpen} size="small" onClose={() => { if (!deleteLoading) { setDeleteConfirmOpen(false); setDeleteTargetRow(null); } }} className="custom-modal">
        <Modal.Content>
          <button type="button" className="close linear-gradient" onClick={() => { if (!deleteLoading) { setDeleteConfirmOpen(false); setDeleteTargetRow(null); } }} data-dismiss="modal" aria-label="Close">X</button>
          <div className="modal-header"><h5 className="modal-title">Confirm your action</h5></div>
          <p className="custom-modal-content">Are you sure you want to delete?</p>
        </Modal.Content>
        <div className="modal-footer">
          <button type="button" className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small" onClick={() => { if (!deleteLoading) { setDeleteConfirmOpen(false); setDeleteTargetRow(null); } }} data-dismiss="modal"><span>No</span></button>
          <button type="button" onClick={() => { if (!deleteLoading && deleteTargetRow) handleDeleteVariableRow(deleteTargetRow); }} className="btn linear-gradient yr-submitbtn btn-sm" disabled={deleteLoading}>Yes</button>
        </div>
      </Modal>
    </>
  );
};

export default Dataconnectionwrapper;